<template>
  <div class="card-number-wrapper">
    <sdk-input @blur="onBlur" @focus="onFocus" @input="onInput" :style="inputStyle" :placeholder="placeholder" />
    <img :src="cardImg" />
  </div>
</template>
<script>
import SdkInput from '@/views/sdk/components/sdk-input.vue'
import { onCardInput, rules } from '@/utils/tools/checkout'
import { sendMessageToClient, getFormatMessage, encryptData } from '@/views/sdk/tools'
import { postJsSDKPayment } from '@/views/sdk/api'

export default {
  name: 'card-number',
  components: { SdkInput },
  data() {
    return {
      inputValue: '',
      options: {},
      isError: false,
      cardImg: require('@/assets/images/checkout/card.png'),
      inputStyle: {},
      placeholder: ''
    }
  },
  created() {
    window.addEventListener('message', this.listeningMessage)
    this.$store.dispatch('app/setShowTips', false)
  },
  methods: {
    uniformResults(results) {
      const data = { ...results }
      if (results.status) {
        data.code = results.status
      }
      return data
    },
    verificationForm(cardParams) {
      if (this.isError) {
        return false
      }
      if (!cardParams.expiredMonth?.trim() || !cardParams.expiredYear?.trim()) {
        return false
      }

      if (!cardParams.cvv?.trim()) {
        return false
      }
      if (!cardParams.cardholder?.trim()) {
        return false
      } else if (cardParams.cardholder?.includes('undefined')) {
        return false
      } else {
        const array = cardParams.cardholder.split(' ')
        if (!array.length || array.some((item) => !item?.trim())) {
          return false
        }
      }
      return true
    },
    listeningMessage(messageData) {
      const { event, data } = getFormatMessage(messageData, this.$route) || {}
      switch (event) {
        case 'sdk_checkout__settings': {
          this.options = data
          this.inputStyle = data?.inputStyle || {}
          this.placeholder = data?.inputPlaceholder?.cardNumber || ''
          break
        }
        case 'sdk_checkout__validator': {
          this.sendErrorMessage(this.inputValue)
          break
        }
        case 'sdk_checkout__card_no_collect': {
          const params = { ...data }
          if (!this.verificationForm(params.card) || !this.options?.verificationData?.key) {
            sendMessageToClient(
              'sdk_checkout_payment_completed',
              this.uniformResults({
                code: 4001,
                message: 'Incorrect information',
                status: 4001
              }),
              this.$route
            )
            return
          }

          params.card.cardNumber = encryptData(
            this.inputValue,
            this.options?.verificationData?.key,
            this.options?.verificationData?.iv
          )
          params.card.cardholder = encryptData(
            params.card.cardholder,
            this.options?.verificationData?.key,
            this.options?.verificationData?.iv
          )

          postJsSDKPayment(params, this.options?.verificationData?.token)
            .then((res) => {
              sendMessageToClient('sdk_checkout_payment_completed', this.uniformResults(res), this.$route)
            })
            .catch((err) => {
              sendMessageToClient('sdk_checkout_payment_completed', this.uniformResults(err), this.$route)
            })
          break
        }
      }
    },
    sendErrorMessage(value) {
      rules.cardNumber(null, value, (error, typeCode) => {
        this.isError = !!error
        if (this.isError) {
          sendMessageToClient('sdk_checkout__form_verify', { typeCode }, this.$route)
        } else {
          sendMessageToClient('sdk_checkout__form_verify', { typeCode: '15010' }, this.$route)
        }
      })
    },
    onInput(event) {
      onCardInput(event, (value, card) => {
        event.target.value = value
        this.inputValue = value
        this.cardImg = !card ? require('@/assets/images/checkout/card.png') : card.logo
        if (this.options.errorTrigger === 'change') {
          this.sendErrorMessage(value)
        }
        sendMessageToClient('sdk_checkout__card_type', { cardType: card }, this.$route)
      })
      sendMessageToClient('sdk_checkout__style_event_change', { type: 'card_number_change' }, this.$route)
    },
    onFocus() {
      sendMessageToClient('sdk_checkout__style_event_change', { type: 'card_number_focus' }, this.$route)
    },
    onBlur() {
      sendMessageToClient('sdk_checkout__style_event_change', { type: 'card_number_blur' }, this.$route)
      if (this.options.errorTrigger === 'blur') {
        this.sendErrorMessage(this.inputValue)
      }
    }
  },
  watch: {
    '$store.getters.app.currentLan': 'onLanguageChange'
  }
}
</script>
<style lang="less">
@import '~@/styles/common.less';
.card-number-wrapper {
  width: 100%;
  height: 100%;
  line-height: 100%;
  position: relative;
  padding-right: 55px;

  img {
    position: absolute;
    top: 50%;
    right: 0;
    height: 16px;
    transition: all 0.3s ease-in;
    transform: translateY(-50%);
  }
}
</style>
